<template>
  <div>
    <el-divider v-if="patentData.lg !== 1" content-position="left">附图</el-divider>
    <el-carousel v-if="patentData.lg !== 1" :interval="4000" type="card" height="200px">
      <el-carousel-item v-for="item in patentData.detail.picList" :key="item">
        <el-image :src="item" style="width: 400px; height: 200px" fit="fill" :preview-src-list="patentData.detail.picList"></el-image>
      </el-carousel-item>
    </el-carousel>
    <el-divider content-position="left">说明书</el-divider>
    <div class="shuoming-text" v-html="patentData.detail.instrPath"></div>
    <el-divider content-position="left">权利要求</el-divider>
    <div class="shuoming-text" v-html="patentData.detail.claimsPath"></div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      patentData: null
    }
  },
  created() {

  },
  mounted() {
    this.patentData = this.data;
  },
  methods: {

  }
}
</script>

<style>
.shuoming-text {
  width: 100%;
  height: auto;
  font-size: 12px;
}
</style>